// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0px;
  font-family: Inter;
  font-style: normal;
  box-shadow: none;
}

.tool-box-container {
  width: 100%;
  background: var(--surface-secondary) !important;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.home-page-toolbar {
  width: calc(100% - 14rem) !important;
  justify-content: space-between !important;
}
@media (max-width: 911px) {
  .home-page-toolbar {
    width: calc(100% - 10rem) !important;
  }
}
@media (max-width: 810px) {
  .home-page-toolbar {
    width: auto !important;
  }
}

.tool-box, .dialog-tool-box {
  height: 5rem;
  min-height: 5rem;
  width: calc(100vw - 8rem);
  margin: auto;
}
@media (max-width: 850px) {
  .tool-box, .dialog-tool-box {
    width: calc(100vw - 2rem);
  }
}
@media (max-width: 604px) {
  .tool-box, .dialog-tool-box {
    width: calc(100vw - 1rem);
  }
}
@media (max-width: 576px) {
  .tool-box, .dialog-tool-box {
    width: calc(100vw - 2rem);
    height: calc(3.5rem + env(safe-area-inset-top, 0px));
    min-height: 3.5rem;
    font-size: 1.25rem;
    font-weight: 600;
    text-align: left;
  }
}

@media (max-width: 604px) {
  .dialog-tool-box {
    width: calc(100vw - 2rem);
  }
}

.sign-up-logo {
  min-width: 9.5rem;
}

.logo-container, .other-login-logo-container {
  color: var(--text-primary);
  font-weight: 600;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  margin-top: -0.563rem;
}
.logo-container .back-icon, .other-login-logo-container .back-icon {
  margin-right: 1.75rem;
  font-size: 1.5rem;
  color: var(--text-secondary);
}
.logo-container h1, .other-login-logo-container h1 {
  font-size: 1.25rem;
  color: var(--text-primary);
  font-weight: 600;
}
@media (max-width: 310px) {
  .logo-container h1, .other-login-logo-container h1 {
    font-size: 0.875rem;
  }
}
@media (max-width: 400px) {
  .logo-container, .other-login-logo-container {
    padding-right: 1rem;
  }
}
@media (max-width: 332px) {
  .logo-container h1, .other-login-logo-container h1 {
    font-size: 0.9375rem;
  }
}

.other-login-logo-container {
  justify-content: center;
}
@media (max-width: 576px) {
  .other-login-logo-container {
    padding-right: 0px !important;
    margin-top: 0px !important;
  }
}

.logo, .other-logo {
  position: relative;
  top: 0.25rem;
}
@media (max-width: 576px) {
  .logo, .other-logo {
    height: 22px;
    width: 22px;
  }
}

.logo-wordmark {
  height: 1.75rem;
  width: auto;
  margin-top: 0.563rem;
}
@media (max-width: 576px) {
  .logo-wordmark {
    height: 1.25rem;
  }
}

.logo-wordmark--light {
  display: block;
}

.logo-wordmark--dark {
  display: none;
}

:host-context(body.dark) .logo-wordmark--light {
  display: none;
}
:host-context(body.dark) .logo-wordmark--dark {
  display: block;
}

.logo-text {
  display: inline-block;
  font-size: 1.688rem !important;
  margin: 0px 0px -0.25rem 0.75rem;
}
.logo-text .accent-text {
  color: var(--color-accent);
}
@media (max-width: 576px) {
  .logo-text {
    font-size: 1.2rem !important;
    margin: 0px 0px -0.25rem 0.5rem;
  }
}

.plus-sigin {
  font-size: 1.688rem !important;
  margin-top: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (max-width: 576px) {
  .plus-sigin {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}

.button-container {
  margin-right: -0.125rem;
  height: 100%;
  display: flex;
  align-items: center;
}

.new-signup-buttons {
  width: 100%;
  justify-content: space-between;
}
@media (max-width: 576px) {
  .new-signup-buttons {
    width: auto;
  }
}

.closeX-button {
  margin-right: 0rem !important;
}

.contact-tool-box {
  min-height: 5rem;
}
.contact-tool-box .contact-list-title {
  color: var(--text-primary);
}
.contact-tool-box .contact-list-title h1 {
  font-size: 1.25rem;
  font-weight: 600;
  text-align: left;
  margin-left: 1rem;
}
.contact-tool-box .contact-list-title-small h1 {
  font-size: 0.625rem;
  font-weight: 500;
  text-align: left;
  margin-left: 0rem;
}

.new-sign-up-background {
  min-width: 9.75rem;
  background: var(--surface-primary) !important;
}

.footer-tool-box {
  height: calc(3.5rem + env(safe-area-inset-bottom, 0px));
  min-height: 3.5rem;
  margin: auto;
  max-width: 42rem;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}
.footer-tool-box .home-page-footer {
  width: 100%;
  height: calc(3.5rem + env(safe-area-inset-bottom, 0px));
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.invite-contact-modal h1 {
  color: var(--text-primary);
  font-weight: 600;
  font-size: 1.25rem;
}

.support-page {
  justify-content: flex-start !important;
}

@media (max-width: 576px) {
  .support-logo {
    top: 0px !important;
  }
}

@media (max-width: 576px) {
  .support-text {
    margin: 0px 0px 0rem 0.5rem;
  }
}

.show-environment-report {
  display: flex;
  align-items: center;
}
.show-environment-report app-icon {
  height: 20px;
  width: 20px;
  transform: rotate(-275deg);
}

.icon-background {
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: #4C17CA;
  border-radius: 50%;
  margin-right: 0.75rem;
}

.icon-background-hybrid {
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: darkgrey;
  border-radius: 50%;
  margin-right: 0.75rem;
}

.Webex {
  max-width: 150px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/sign-up-toolbar/sign-up-toolbar.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,+CAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;;AAEA;EACI,oCAAA;EACA,yCAAA;AACJ;AACI;EAJJ;IAKQ,oCAAA;EAEN;AACF;AAAI;EARJ;IASQ,sBAAA;EAGN;AACF;;AAAA;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAGJ;AADI;EANJ;IAOQ,yBAAA;EAIN;AACF;AAFI;EAVJ;IAWQ,yBAAA;EAKN;AACF;AAHI;EAdJ;IAeQ,yBAAA;IACA,oDAAA;IACA,kBAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;EAMN;AACF;;AAAI;EAHJ;IAIQ,yBAAA;EAIN;AACF;;AADA;EACI,iBAAA;AAIJ;;AADA;EACI,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAIJ;AAFI;EACI,qBAAA;EACA,iBAAA;EACA,4BAAA;AAIR;AADI;EACI,kBAAA;EACA,0BAAA;EACA,gBAAA;AAGR;AADQ;EALJ;IAMQ,mBAAA;EAIV;AACF;AADI;EAxBJ;IAyBQ,mBAAA;EAIN;AACF;AAFI;EACI;IACI,oBAAA;EAIV;AACF;;AAAA;EAEI,uBAAA;AAEJ;AAAI;EAJJ;IAKQ,6BAAA;IACA,0BAAA;EAGN;AACF;;AAAA;EACI,kBAAA;EACA,YAAA;AAGJ;AADI;EAJJ;IAKQ,YAAA;IACA,WAAA;EAIN;AACF;;AADA;EACI,eAAA;EACA,WAAA;EACA,oBAAA;AAIJ;AAFI;EALJ;IAMQ,eAAA;EAKN;AACF;;AAFA;EACI,cAAA;AAKJ;;AAFA;EACI,aAAA;AAKJ;;AADI;EACI,aAAA;AAIR;AADI;EACI,cAAA;AAGR;;AAKA;EACI,qBAAA;EACA,8BAAA;EACA,gCAAA;AAFJ;AAII;EACI,0BAAA;AAFR;AAKI;EATJ;IAUQ,4BAAA;IACA,+BAAA;EAFN;AACF;;AAKA;EACI,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAII;EANJ;IAOQ,qBAAA;IACA,sBAAA;EADN;AACF;;AAIA;EACI,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AADJ;;AAIA;EACI,WAAA;EACA,8BAAA;AADJ;AAGI;EAJJ;IAKQ,WAAA;EAAN;AACF;;AAGA;EACI,6BAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;AAEI;EACI,0BAAA;AAAR;AAEQ;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAAZ;AAKQ;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAHZ;;AAQA;EACI,kBAAA;EACA,6CAAA;AALJ;;AASA;EACI,uDAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;AANJ;AAQI;EACI,WAAA;EACA,uDAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AANR;;AAWI;EACI,0BAAA;EACA,gBAAA;EACA,kBAAA;AARR;;AAYA;EACI,sCAAA;AATJ;;AAaI;EADJ;IAEQ,mBAAA;EATN;AACF;;AAaI;EADJ;IAEQ,2BAAA;EATN;AACF;;AAYA;EACI,aAAA;EACA,mBAAA;AATJ;AAWI;EACI,YAAA;EACA,WAAA;EACA,0BAAA;AATR;;AAcA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AAXJ;;AAcA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;AAXJ;;AAcA;EACI,gBAAA;AAXJ","sourcesContent":["* {\n    margin: 0px;\n    padding: 0px;\n    font-family: Inter;\n    font-style: normal;\n    box-shadow: none;\n}\n\n.tool-box-container {\n    width: 100%;\n    background: var(--surface-secondary) !important;\n}\n\n.toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.home-page-toolbar {\n    width: calc(100% - 14rem) !important;\n    justify-content: space-between !important;\n\n    @media(max-width: 911px) {\n        width: calc(100% - 10rem) !important;\n    }\n\n    @media(max-width: 810px) {\n        width: auto !important;\n    }\n}\n\n.tool-box {\n    height: 5rem;\n    min-height: 5rem;\n    width: calc(100vw - 8rem);\n    margin: auto;\n\n    @media(max-width: 850px) {\n        width: calc(100vw - 2rem);\n    }\n\n    @media(max-width: 604px) {\n        width: calc(100vw - 1rem);\n    }\n\n    @media(max-width: 576px) {\n        width: calc(100vw - 2rem);\n        height: calc(3.5rem + env(safe-area-inset-top, 0px));\n        min-height: 3.5rem;\n        font-size: 1.25rem;\n        font-weight: 600;\n        text-align: left;\n    }\n}\n\n.dialog-tool-box {\n    @extend .tool-box;\n\n    @media(max-width: 604px) {\n        width: calc(100vw - 2rem);\n    }\n}\n\n.sign-up-logo {\n    min-width: 9.5rem;\n}\n\n.logo-container {\n    color: var(--text-primary);\n    font-weight: 600;\n    font-size: 1.25rem;\n    display: flex;\n    align-items: center;\n    margin-top: -0.563rem;\n\n    .back-icon {\n        margin-right: 1.75rem;\n        font-size: 1.5rem;\n        color: var(--text-secondary);\n    }\n\n    h1 {\n        font-size: 1.25rem;\n        color: var(--text-primary);\n        font-weight: 600;\n\n        @media(max-width: 310px) {\n            font-size: 0.875rem;\n        }\n    }\n\n    @media(max-width: 400px) {\n        padding-right: 1rem;\n    }\n\n    @media(max-width: 332px) {\n        h1 {\n            font-size: 0.9375rem;\n        }\n    }\n}\n\n.other-login-logo-container {\n    @extend .logo-container;\n    justify-content: center;\n\n    @media(max-width: 576px) {\n        padding-right: 0px !important;\n        margin-top: 0px !important;\n    }\n}\n\n.logo {\n    position: relative;\n    top: 0.25rem;\n\n    @media(max-width: 576px) {\n        height: 22px;\n        width: 22px;\n    }\n}\n\n.logo-wordmark {\n    height: 1.75rem;\n    width: auto;\n    margin-top: 0.563rem;\n\n    @media(max-width: 576px) {\n        height: 1.25rem;\n    }\n}\n\n.logo-wordmark--light {\n    display: block;\n}\n\n.logo-wordmark--dark {\n    display: none;\n}\n\n:host-context(body.dark) {\n    .logo-wordmark--light {\n        display: none;\n    }\n\n    .logo-wordmark--dark {\n        display: block;\n    }\n}\n\n.other-logo {\n    @extend .logo;\n}\n\n.logo-text {\n    display: inline-block;\n    font-size: 1.688rem !important;\n    margin: 0px 0px -0.25rem 0.75rem;\n\n    .accent-text {\n        color: var(--color-accent);\n    }\n\n    @media(max-width: 576px) {\n        font-size: 1.2rem !important;\n        margin: 0px 0px -0.25rem 0.5rem;\n    }\n}\n\n.plus-sigin {\n    font-size: 1.688rem !important;\n    margin-top: 0.5rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n\n    @media(max-width: 576px) {\n        padding-left: 0.75rem;\n        padding-right: 0.75rem;\n    }\n}\n\n.button-container {\n    margin-right: -0.125rem;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.new-signup-buttons {\n    width: 100%;\n    justify-content: space-between;\n\n    @media(max-width: 576px) {\n        width: auto;\n    }\n}\n\n.closeX-button {\n    margin-right: 0rem !important;\n}\n\n.contact-tool-box {\n    min-height: 5rem;\n\n    .contact-list-title {\n        color: var(--text-primary);\n\n        h1 {\n            font-size: 1.25rem;\n            font-weight: 600;\n            text-align: left;\n            margin-left: 1rem;\n        }\n    }\n\n    .contact-list-title-small {\n        h1 {\n            font-size: 0.625rem;\n            font-weight: 500;\n            text-align: left;\n            margin-left: 0rem;\n        }\n    }\n}\n\n.new-sign-up-background {\n    min-width: 9.75rem;\n    background: var(--surface-primary) !important;\n}\n\n\n.footer-tool-box {\n    height: calc(3.5rem + env(safe-area-inset-bottom, 0px));\n    min-height: 3.5rem;\n    margin: auto;\n    max-width: 42rem;\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n\n    .home-page-footer {\n        width: 100%;\n        height: calc(3.5rem + env(safe-area-inset-bottom, 0px));\n        display: flex;\n        justify-content: space-evenly;\n        align-items: center;\n    }\n}\n\n.invite-contact-modal {\n    h1 {\n        color: var(--text-primary);\n        font-weight: 600;\n        font-size: 1.25rem;\n    }\n}\n\n.support-page {\n    justify-content: flex-start !important;\n}\n\n.support-logo {\n    @media(max-width: 576px) {\n        top: 0px !important;\n    }\n}\n\n.support-text {\n    @media(max-width: 576px) {\n        margin: 0px 0px 0rem 0.5rem;\n    }\n}\n\n.show-environment-report {\n    display: flex;\n    align-items: center;\n\n    app-icon {\n        height: 20px;\n        width: 20px;\n        transform: rotate(-275deg);\n\n    }\n}\n\n.icon-background {\n    height: 32px;\n    width: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    background: #4C17CA;\n    border-radius: 50%;\n    margin-right: 0.75rem;\n}\n\n.icon-background-hybrid {\n    height: 32px;\n    width: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    background: darkgrey;\n    border-radius: 50%;\n    margin-right: 0.75rem;\n}\n\n.Webex {\n    max-width: 150px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
